import { useSelector } from 'react-redux';

const useWorkflowsDropdown = ({ category }) => {
  const { readStatus, results } = useSelector(({ workflows: { workflows } }) => workflows[category]);
  return { readStatus, workflows: results };
};

export default {
  useWorkflowsDropdown,
};
